import { deleteCmsCourseMeta, updateCmsCourseMeta } from 'api/generated/user-cms-metadata-controller/user-cms-metadata-controller';

import { CmsCourseUpdateRequestStatus } from 'api/generated/schemas/cmsCourseUpdateRequestStatus';

interface StartCourseArgs {
  userId: string | undefined;
  courseId: string | number | undefined;
}

/** Coerce Strapi / route ids into numbers for CMS metadata API path params. */
export const parseCmsNumericId = (id: string | number): number => {
  const n = typeof id === 'number' ? id : Number(id);

  if (!Number.isFinite(n)) {
    throw new RangeError(`Invalid CMS numeric id: ${String(id)}`);
  }

  return n;
};

export const startCourse = async ({ userId, courseId }: StartCourseArgs): Promise<void> => {
  if (!userId || courseId === undefined) {
    return;
  }

  await updateCmsCourseMeta(userId, parseCmsNumericId(courseId), {
    status: CmsCourseUpdateRequestStatus.IN_PROGRESS,
  }).catch(console.error);
};

export const restartCourse = async ({ userId, courseId }: StartCourseArgs): Promise<void> => {
  if (!userId || courseId === undefined) {
    return;
  }

  await deleteCmsCourseMeta(userId, parseCmsNumericId(courseId))
    .then(() => startCourse({ userId, courseId }))
    .catch(console.error);
};

interface ComponentHeights {
  globalFooterHeight?: number;
  globalHeaderHeight?: number;
  screenHeaderHeight?: number;
}

export const getComponentHeights = (): ComponentHeights => {
  const globalHeaderHeight =
    document.querySelector('.global-header')?.clientHeight;
  const globalFooterHeight =
    document.querySelector('.global-footer')?.clientHeight;
  const screenHeaderHeight = document.querySelector(
    '.course-details-header'
  )?.clientHeight;

  return {
    globalFooterHeight,
    globalHeaderHeight,
    screenHeaderHeight,
  };
};

export const countAverageProgress = (
  lessonsProgress: Record<string, number>,
): number => {
  const totalProgress = Object.values(lessonsProgress).reduce(
    (total, progress) => total + progress,
    0
  );

  return Math.round(totalProgress / Object.keys(lessonsProgress).length);
};
